// extracted by mini-css-extract-plugin
module.exports = {"reasonItem":"style_reasonItem__wzsik","reasonName":"style_reasonName__OJzYV","reasonCurrentIcon":"style_reasonCurrentIcon__3gRiE"};